// Export dialog priority list from TravelMap component
export enum ACCOMMODATIONS_DIALOGS {
  VENUE_DIALOG = 'venueDialog',
  ACCOMMODATION_TOUR_TOOLTIP = 'accommodationTourTooltip',
  AI_RECOMMENDATIONS_FEEDBACK = 'aiRecommendationsFeedbackDialog',
  EXPANDED_MAP_ANNOUNCEMENT = 'expandedMapAnnouncementDialog',
}

export const ACCOMMODATIONS_DIALOG_PRIORITY: readonly string[] = [
  ACCOMMODATIONS_DIALOGS.VENUE_DIALOG,
  ACCOMMODATIONS_DIALOGS.ACCOMMODATION_TOUR_TOOLTIP,
  ACCOMMODATIONS_DIALOGS.AI_RECOMMENDATIONS_FEEDBACK,
  ACCOMMODATIONS_DIALOGS.EXPANDED_MAP_ANNOUNCEMENT,
];
